// @flow
import { prepareAcceptMediaStreamHeaders } from '@alphaott/drm-web'

// Web OS http://webostv.developer.lge.com/discover/specifications/supported-media-formats/
// Tizen https://developer.samsung.com/smarttv/develop/specifications/media-specifications.html
export const acceptMediaStream = prepareAcceptMediaStreamHeaders()

export default prepareAcceptMediaStreamHeaders
